<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        components: {
            
        },
        name: "App"
    };
</script>
<style>
    @import './assets/css/index.css';
    #app{
        background: #f2f2f2;
    }
    .app_container {
        width: 80%;
        max-width: 2000px;
        margin: 0 auto;
        display: block;
    }
    /* #app{
        background: #f2f2f2;
    }
    .app_container {
        margin-right: auto;
        margin-left: auto;
    }
    @media (min-width: 768px) {
        .app_container {
            width: 750px;
        }
    }
    @media (min-width: 992px) {
        .app_container {
            width: 970px;
        }
    }
    @media (min-width: 1522px) {
        .app_container {
            width: 1522px;
        }
    } */
</style>




// WEBPACK FOOTER //
// src/App.vue